<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelims-head" lang="en-GB">Also by the Author</h1>
<p class="Prelims-main" lang="en-GB"><em class="italic" lang="en-GB">Orange Lilies of Dallington Place</em> (2018)</p>
<p class="Prelims-main" lang="en-GB"><em class="italic" lang="en-GB">After The War Comes Love</em>, Volume 1 (2020) </p>
<p class="Prelims-main _idGenParaOverride-1" lang="en-GB"><em class="italic" lang="en-GB">Whisper</em> (2020)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB1.vue?3e1ae1ea